import { ExamSearchListPage } from './ExamSearchListPage';
export default ExamSearchListPage;
